/**
 * File: wpBlockColumns.js.
 *
 * initialize new class to wp column block on wp
 */

export default {
  wpColumns: document.querySelectorAll('.wp-block-columns'),
  init() {
    if (this.wpColumns.length > 0) {
      this.render();
    }
  },
  render() {
    const siteMain = document.querySelector('.site-main');
    // add has-wp-columns class if there are wp column block to post
    siteMain.classList.add('has-wp-columns');

    // add container and wp-columns classes
    [ ...this.wpColumns ].forEach((columns) => {
      columns.classList.add('container');
      columns.classList.add('wp-columns');
      const children = columns.querySelectorAll('.wp-block-column');
      [ ...children ].forEach((child, i) => {
        child.classList.add(`wp-columns__column-${ i + 1 }`);
      });
    });
  },
  finalize() {
  // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
